/**
 * The capability-level legend and the two filters that dim the globe.
 *
 * Deliberately knows nothing about the drawer or the panels: the region chips
 * that open a region profile are wired in main.js, so the dependency between
 * this module and the panels only ever points one way.
 */
import { C, TIER_COLORS, TIER_LABEL, TIER_NAME, tierOf, hasDim } from '../model.js';
import { mapView, metricOf, setDim } from '../globe/texture.js';
import { h } from '../untrusted.js';

let tierFilter = null, regionFilter = null;
const lrows = document.getElementById('lrows');

export function renderLegend(){
  document.getElementById('legendTitle').textContent =
    'Capability level · ' + (mapView.colorMode==='overall' ? 'Overall' : mapView.colorMode);
  if(mapView.colorMode!=='overall' && !hasDim(mapView.colorMode)){
    lrows.innerHTML = String(h`<div class="lnote">Not collected in this delivery</div>`);
    return;
  }
  lrows.innerHTML = String(h`${TIER_LABEL.map((lb,i)=>{
    const n=C.filter(c=>tierOf(metricOf(c))===i).length;
    return h`<button class="lrow ${tierFilter===i?'on':''}" data-t="${i}">
      <span class="sw" style="background:${TIER_COLORS[i]};color:${TIER_COLORS[i]}"></span>
      <span class="ln">${TIER_NAME[i]}</span><span class="lc">${n}</span></button>`;
  })}`);
  lrows.querySelectorAll('.lrow').forEach(b=> b.onclick=()=>{ tierFilter=tierFilter===+b.dataset.t?null:+b.dataset.t; applyFilters(); renderLegend() });
}
export function applyFilters(){
  const dim=new Set();
  C.forEach(c=>{
    if(!c.id) return;
    const mv=metricOf(c);
    if((tierFilter!=null && (mv==null || tierOf(mv)!==tierFilter)) || (regionFilter && c.r!==regionFilter)) dim.add(c.id);
  });
  setDim(dim.size?dim:null);
}

/** Region chips own the region filter; the legend owns the level filter. */
export function setRegionFilter(r) { regionFilter = r; applyFilters() }
